import '../../../vendors/viewerjs/viewer.css';
import Viewer from '../../../vendors/viewerjs/viewer.esm.js';

export default Viewer;
